module.exports = __webpack_public_path__ + "img/Logo_Full-24x24.c2babaac.png";